// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__iCtvG","title":"Info_title__3DFpX","links":"Info_links__1tySK","link":"Info_link__3M9fq","logo":"Info_logo__krmHV"};